
export default {
  name: 'AToggle',
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reverse: {
      type: Boolean,
      default: false,
    },
    toggleClass: {
      type: String,
      default: '',
    },
    checkedText: {
      type: String,
      default: null,
    },
    uncheckedText: {
      type: String,
      default: null,
    },
    width: {
      type: [Number, String],
      default: 75,
    },
    height: {
      type: [Number, String],
      default: 25,
    },
    bgCheckedClass: {
      type: String,
      default: 'bg-gray-4',
    },
    bgUncheckedClass: {
      type: String,
      default: 'bg-gray-4',
    },
    bgUndefinedClass: {
      type: String,
      default: 'bg-gray-4',
    },
    bgDisabledClass: {
      type: String,
      default: 'bg-disabled',
    },
    dotColor: {
      type: String,
      default: '#fff',
    },
    fontSize: {
      type: [Number, String],
      default: '13',
    },
    checkedColor: {
      type: String,
      default: '#fff',
    },
    uncheckedColor: {
      type: String,
      default: '#fff',
    },
    fontWeight: {
      type: [Number, String],
      default: 'normal',
    },
  },
  computed: {
    bgClass() {
      let bg = '';
      if (this.value && !this.disabled) {
        bg = this.bgCheckedClass;
      }
      if (this.value === false && !this.disabled) {
        bg = this.bgUncheckedClass;
      }
      if (this.value === null && !this.disabled) {
        bg = this.bgUndefinedClass;
      }
      if (this.disabled) {
        bg = this.bgDisabledClass;
      }
      return bg;
    },
    bgStyle() {
      const styles = {
        width: `${this.width}px`,
        height: `${this.height}px`,
      };
      if (this.disabled) {
        styles.cursor = 'not-allowed';
      }
      return styles;
    },
    dotStyle() {
      const getMarginLeft = () => {
        if (this.value) {
          return `${this.width - (this.height - 3)}px`;
        }
        if (this.value === false) {
          return '5px';
        }
        return `${this.width / 2 - (this.height / 2 - 3)}px`;
      };

      const styles = {
        background: this.dotColor,
        width: `${this.height - 8}px`,
        height: `${this.height - 8}px`,
        'min-width': `${this.height - 8}px`,
        'min-height': `${this.height - 8}px`,
        'margin-left': getMarginLeft(),
      };

      if ((this.value === false && this.reverse) || (this.value && !this.reverse)) {
        styles.marginLeft = `${this.width - (this.height - 3)}px`;
      }
      if ((this.value && this.reverse) || (this.value === false && !this.reverse)) {
        styles.marginLeft = '5px';
      }
      return styles;
    },
    textStyle() {
      const styles = {
        'font-weight': this.fontWeight,
        'font-size': `${this.fontSize}px`,
        color: this.value && !this.disabled ? this.checkedColor : this.uncheckedColor,
        right: this.value ? `${this.height + 4}px` : 'auto',
        left: this.value ? 'auto' : `${this.height + 1}px`,
      };
      if (!this.value && this.reverse) {
        styles.right = `${this.height - 3}px`;
        styles.left = 'auto';
      }
      if (this.value && this.reverse) {
        styles.left = `${this.height - 3}px`;
        styles.right = 'auto';
      }
      return styles;
    },
  },
};
